import type { APIError, JsonApiResponse } from '~/interfaces/api/main';

export const createApiError = (fallbackMessage: string, apiErrors?: APIError[] | null) => {
  const first = apiErrors?.[0];
  const error = new Error(first?.detail ?? first?.title ?? fallbackMessage);
  (error as any).apiErrors = apiErrors && apiErrors.length ? apiErrors : null;
  return error;
};

/**
 * Extrait un item depuis une réponse API qui peut être wrappée dans { data } ou retournée directement.
 * Certains endpoints Symfony retournent l'objet directement, d'autres dans un wrapper JsonApiResponse.
 */
export function unwrapApiItem<T extends { id: unknown }> (response: JsonApiResponse<T> | T): T | null {
  const payload = response as JsonApiResponse<T>;
  if (payload.data) {
    return payload.data;
  }
  if ('id' in response) {
    return response as T;
  }
  return null;
}

// Source unique de la clé backend `filters[statement.monthNumber][]`.
export function buildStatementMonthFilterParams (months: Array<string | number>): string[] {
  return months.map(month => `filters[statement.monthNumber][]=${month}`);
}

export interface SortParam {
  field: string;
  direction: 'ASC' | 'DESC';
}

export function buildSortParams (sorts: SortParam[]): string[] {
  return sorts.flatMap((sort, index) => [
    `sort[${index}][field]=${sort.field}`,
    `sort[${index}][direction]=${sort.direction}`,
  ]);
}
